import * as Types from './types'

export default {
  [Types.SET_CUSTOMER]: (state, payload) => {
    state.buyer = payload
  },
  [Types.SET_SELECTED_CUSTOMER]: (state, payload) => {
    state.selectedBuyer = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/buyer/mutations.js